export const tlieSources = {
  mainSiteUrl: 'https://www.tlie.org/',
  phone: '800-252-9332',
  formattedPhone: '(800) 252-9332',
  applicationFax: '512-482-8738',
  contactNumber: '512-480-9074',
  infoEmail: 'info@tlie.org',
  applicationEmail: 'app@tlie.org',
  accBusinessUrl: 'https://www.bbb.org/',
  privacyPolicyUrl: 'https://www.tlie.org/about/privacy-policy/',
  subscribeUrl: 'http://tlie.us1.list-manage.com/subscribe?u=53b3663e1def4adee80ed414d&id=5f665481d3',
  quotePolicyRegular: 'https://www.tlie.org/wp-content/uploads/2025/07/Specimen-Premier-P-12.pdf',
  quotePolicyBasic: 'https://www.tlie.org/wp-content/uploads/2025/07/Specimen-Essential-E-5.pdf',
  quotePolicyJudge: 'https://www.tlie.org/wp-content/uploads/2025/07/Specimen-Judge-J-5.pdf',
  cyberRiskManagement: 'https://tlie.nascybernet.com/?login&uoid=21069&hash=b56e0b4ea4962283bee762525c2d490f',
  preventionUrl: 'http://www.tlie.org/prevention',
  policiesUrl: 'https://www.tlie.org/purchasing-insurance/insurance-policies/'
}